type Status = 'finished' | 'expired' | 'active' | 'scheduled';

type Props = {
    used: boolean | null | undefined;
    validFrom: string | null | undefined;
    validTo: string | null | undefined;
};

function computeStatus({ used, validFrom, validTo }: Props): Status {
    if (used) return 'finished';
    const now = Math.floor(Date.now() / 1000);
    if (validTo && parseInt(validTo, 10) < now) return 'expired';
    if (validFrom && parseInt(validFrom, 10) > now) return 'scheduled';
    return 'active';
}

const LABEL: Record<Status, string> = {
    finished: 'Odehraná',
    expired: 'Expirovaná',
    active: 'Aktivní',
    scheduled: 'Naplánovaná',
};

export default function GameStatusBadge(props: Props) {
    const status = computeStatus(props);
    return <span className={`status-badge status-badge--${status}`}>{LABEL[status]}</span>;
}
